import React from 'react';
import { PocListItem } from 'commons/components/components-wrapper';

export interface ListItemProps {
    id: string;
    label: string;
    prefixSlot?: React.ReactNode;
    suffixSlot?: React.ReactNode;
    onClick: () => void | Promise<void>;
    disabled?: boolean;
    value?: string;
    className?: string;
}

export const ListItem: React.FC<ListItemProps> = (props) => {
    const { id, label, prefixSlot, suffixSlot, onClick, disabled, value, className } = props;
    const handleItemClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    return (
        <PocListItem
            id={id}
            value={value ?? id}
            onClick={handleItemClick}
            disabled={disabled}
            className={className}
            data-testid={`list-item-${id}`}
        >
            <div slot="prefix">{prefixSlot}</div>
            {label}
            <div slot="suffix">{suffixSlot}</div>
        </PocListItem>
    );
};
